import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class TaskListsDB extends GenericDB {
  constructor(clientId = null) {
    super('', 'clients.taskLists');
    this.setClientId(clientId);
  }

  setClientId(clientId) {
    this.clientId = clientId;
  }

  getCollectionRef() {
    return collection(db, 'clients', this.clientId, 'taskLists');
  }
}
